import { BaseComponent } from '../../lib/base-component.js';
import { html, nothing } from '../../lib/lit.js';

// A link to something staff published on the community portal, with a copy
// button — the thing to paste into Discord. Renders nothing without an href.
class ShareLink extends BaseComponent {
    static properties = {
        href: { type: String },
        label: { type: String },
        _copied: { state: true },
    };

    constructor() {
        super();
        this.href = '';
        this.label = 'View on portal';
        this._copied = false;
        this._copiedTimer = 0;
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        clearTimeout(this._copiedTimer);
    }

    async _copy() {
        try {
            await navigator.clipboard.writeText(this.href);
            this._copied = true;
            clearTimeout(this._copiedTimer);
            this._copiedTimer = setTimeout(() => {
                this._copied = false;
            }, 1500);
        } catch {
            // Clipboard access refused (insecure context, permissions). The link
            // itself is still right there to copy by hand.
            window.prompt('Copy this link', this.href);
        }
    }

    render() {
        if (!this.href) return nothing;
        return html`
            <span class="d-inline-flex align-items-center gap-1">
                <a class="small" href=${this.href} target="_blank" rel="noopener noreferrer">
                    <i class="bi bi-box-arrow-up-right"></i> ${this.label}
                </a>
                <button
                    class="btn btn-sm btn-link p-0 small"
                    type="button"
                    title="Copy link"
                    aria-label="Copy link"
                    @click=${this._copy}
                >
                    ${this._copied ? html`<i class="bi bi-check-lg text-success"></i> Copied` : html`<i class="bi bi-clipboard"></i>`}
                </button>
            </span>
        `;
    }
}

customElements.define('d3-share-link', ShareLink);
